import React, { useEffect, useState } from 'react'
import style from './style.module.scss'
import axios from 'axios'
import { Http } from "../../../../helpers/axois";
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { KnowledgeBaseAgents } from './knowledgeBaseAgents';
import { WorkflowAgents } from './workFlowAgents';
import aiAgentsIcon from '../../../../assets/svg/ai-agents/emptyAi-agents.svg'
import { Agent, AgentTypes, WorkflowAgent } from './types';
// import { Modal } from '../../../../helpers/commonUi';
import { Icon, Spin, Button, Modal } from 'antd';
import { useToast } from '../../../../helpers/commonFunction/useToast';
import AgentSelector from './menus';
import { motion } from 'framer-motion';
import { pageVariants, pageVariants1 } from './framerAnimations';
import { AppState } from '../../../../stateManager/store';
import NoData from '../../NoData';
import { ReactComponent as WarningIcon } from '../../../../assets/svg/warningIcon.svg'
import { createColorPicker } from './helpers';

function AIAgents() {
  const history = useHistory()
  const pathname = useLocation().pathname
  const locationSplit = pathname.split('/');
  const parts = pathname.split("/");
  const lastPart = parts[parts.length - 1] as AgentTypes;
  const selectedAppType = useSelector(
    (state: any) => state.apps.selectedApp.type
  );
  const appId = locationSplit[3];
  const currentBranch: any = useSelector((state: any) => {
    const selectedAppId = state.apps.selectedApp && state.apps.selectedApp.id
    return (state.apps.appBranch && state.apps.appBranch[selectedAppId]) || {}
  }, (left: any, right: any) => left.branchId === right.branchId)
  const versionId = useSelector((state: any) => {
    return appId && state.apps.appVersion[appId].versionId
  })
  const appPermissions: any = useSelector((state: any) => {
    return state.apps.selectedApp.permissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  const { capabilities = null  } = useSelector((state: any) => state.user.userDetails)
  const branchId = currentBranch && currentBranch.branchId
  const appVersion: { currentVersion: boolean; versionId: string } = useSelector((state: AppState) => state.apps.appVersion[appId]);
  const currentVersion = appVersion && appVersion.currentVersion;
  const canEditAgents = currentVersion && (orgPermissions.includes('aiAgent.Edit') || appPermissions.includes('aiAgent.Edit'))
  const canCreateAgents = currentVersion && (orgPermissions.includes('aiAgent.Create') || appPermissions.includes('aiAgent.Create')) && !capabilities
  const canDeleteAgents = currentVersion && (orgPermissions.includes('aiAgent.Delete') || appPermissions.includes('aiAgent.Delete'))
  const canViewAgent = orgPermissions.includes('aiAgent.View') || appPermissions.includes('aiAgent.View')
  const orgId = useSelector((state: any) => state.org.selectedOrg.id);
  const [agents, setAgents] = useState<Agent[]>([])
  const [app, setApp] = useState<Record<string, any>>({})
  const [loading, setLoading] = useState<boolean>(false)
  const [selectedTab, setSelectedTab] = useState<AgentTypes>(lastPart)
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [deleteAgentData, setDeleteAgentData] = useState<{id: string, name: string}>({id: "", name: ""})
  const [flowAgentsDetails, setFlowAgentDetails] = useState<WorkflowAgent[]>([])
  const [agentName, setAgentName] = useState<string>("")
  const [validateNameError, setValidateNameError] = useState<string>("")
  const { ErrorToast, SuccessToast } = useToast()
  const antIcon = <Icon type="loading" style={{ fontSize: 30 }} spin={true} />
  const selectedOrg = useSelector((state: any) => state.org.selectedOrg)
  const selectedApp = useSelector((state: any) => state.apps.selectedApp)

  // const tabs = [
  //   { name: "Workflow Agent", path: "workFlowAgents" },
  //   ...(selectedAppType === "a8chat" ? [{ name: "Knowledge Base Agent", path: "knowledgeBaseAgents" }] : []),
  // ];

  async function getAgentsForApp(orgId: string, appId: string, agents: Agent[]) {
    const agentIds = agents.map(el => el.id)
    const data: any = await Http.get(`org/${orgId}/apps/${appId}`).toPromise()
    setApp({
      avatar: data[0].avatar,
      displayName: data[0].displayName,
      name: data[0].name,
      type: data[0].type,
      orgId: data[0].orgId,
      teamId: data[0].teamId,
      aiAgents: (data[0].ai_agents ?? []).filter((el: string) => agentIds.includes(el)),
    })
  }

  async function getAgents() {
    if (!window.env.GENAI_URL) {
      return
    }
    setLoading(true)
    const url = `${window.env.GENAI_URL}/api/v1/bot/bots?orgId=${selectedOrg.id}`
    try {
      const { data } = await axios.get(url, {
        headers: {
          'X-STUDIO-TOKEN': localStorage.getItem("studioToken")
        }
      })
      const agents: Agent[] = data.bots.map((bot: any) => ({ id: bot._id, name: bot.name, addAgent: false, removeAgent: false }))
      setAgents(agents)
      return agents
    } catch {
      return []
    } finally {
      setLoading(false)
    }
  }


  async function updateApp(aiAgents: string[]) {
    const formData = new FormData();

    formData.append("name", app.name);
    formData.append("type", app.type);
    formData.append("orgId", app.orgId);
    formData.append("displayName", app.displayName);
    formData.append("aiAgents", JSON.stringify(aiAgents));

    if (app.avatar) {
      formData.append("avatar", app.avatar);
    }

    if (app.teamId) {
      formData.append("teamId", app.avatar);
    }

    await Http.put(`apps/${appId}`, formData).toPromise()
  }

  async function onSelectAgent(agentId: string) {
    let currentAgents: string[] = [...app.aiAgents]
    if (currentAgents.includes(agentId)) {
      currentAgents = currentAgents.filter(el => el !== agentId)
    } else {
      currentAgents = [...currentAgents, agentId]
    }
    await updateApp(currentAgents)
    getAgentsForApp(orgId, appId, agents)
  }

  useEffect(() => {
    if (selectedAppType === "a8chat" && selectedTab === "knowledgeBaseAgents"){
      getAgents().then((agents) => {
        getAgentsForApp(orgId, appId, agents ?? [])
      })
    }
  }, [branchId, versionId, selectedTab])

  const updateActions = (data: boolean, index: number, action: string) => {
    const filteredAgents = agents.map((agent, i) => {
      if (index === i) {
        if (action === "add") {
          agent.addAgent = data
          agent.removeAgent = false
        } else if (action === "remove") {
          agent.removeAgent = data
          agent.addAgent = false
        }
      }

      return agent;
    })
    setAgents(filteredAgents)
  }

  const handleRouteNavigation = (path: AgentTypes) => {
    setSelectedTab(path)
    const locationPath = (selectedAppType === "a8solo" || selectedAppType === "a8chat") ? "/solo" : "/assist"
    history.push("/apps/list/" + appId + locationPath + `/ai-agents/${path}`);
  };


  const getAgentsList = async () => {
    setLoading(true)
    await Http.get(`/apps/${appId}/ai-agents?branchId=${branchId}&versionId=${versionId}`).subscribe((res: any) => {
      if (res.aiAgents) {
        setFlowAgentDetails(res?.aiAgents || [])
        setLoading(false)
      }
      setLoading(false)
    }, (err) => {
      setLoading(false)
      console.log({ err })
    })

  }

  const deleteAgent = (agentId: string) => {
     Http.delete(`/apps/${appId}/ai-agents/${agentId}?branchId=${branchId}&versionId=${versionId}`).subscribe((res: any) => {
      if (res) {
        getAgentsList()
        SuccessToast("Agent deleted successfully")
        setOpenModal(false)
        setDeleteAgentData({ id: "", name: "" })
        setAgentName("")
      }
    }, (err) => {
      ErrorToast("Failed to delete agent")
      console.log({ err })
    })
  }

  useEffect(() => {
    getAgentsList();
  }, [branchId, versionId])

  useEffect(() => {
    if (agentName && agentName !== deleteAgentData.name) {
      setValidateNameError("Please enter valid agent name")
      return
    }
  },[agentName])

  return (
    <>
    {canViewAgent ? <motion.div
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={pageVariants1}
      style={{height: "100%"}}
    >
      <div className={style.aiAgents}>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
          <div>
            <h1>AI Agents</h1>
            <p className={style.subtle}>Add AI agents to your app</p>
          </div>
          {(flowAgentsDetails.length > 0) && canCreateAgents && selectedTab !== "knowledgeBaseAgents" && <button className={style.createAgentBtn} onClick={() => {
            handleRouteNavigation("workFlowAgents/create")
          }}>Add Agent</button>}
        </div>
        <div className={style.divider}></div>
        {/* <div className="left tabs" style={{ marginTop: 20, marginLeft: 0 }}>
          {tabs.map((tab: { name: string, path: string }) => (
            <>
              <p
                data-test-id={`${tab.name}`}
                key={tab.path}
                style={{ marginLeft: 0, color: "#000000", fontSize: 14 }}
                className={`tab ${selectedTab === tab.path ? "active" : ""}`}
                onClick={() => handleRouteNavigation(tab.path as AgentTypes)}
              >
                {tab.name}
              </p>
              <div className={style.divider}></div>
            </>
          ))}
        </div> */}
        {(selectedAppType === "a8chat" && selectedApp.chatType !== "genai") && <AgentSelector handleRouteNavigation={handleRouteNavigation} selectedTab={selectedTab} selectedAppType={selectedAppType}/>}

        {selectedTab === "knowledgeBaseAgents" &&
          <KnowledgeBaseAgents
            app={app}
            agents={agents}
            onSelectAgent={onSelectAgent}
            updateActions={updateActions}
            loading={loading}
          />}

        {loading && selectedTab === "workFlowAgents" && 
          <div className={style.loadingContainer}>
            <Spin indicator={antIcon} style={{ color: '#15808C' }} />
          </div>
        }
        {selectedTab === "workFlowAgents" &&
        <>
          {flowAgentsDetails.length > 0 && !loading && <motion.div
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={pageVariants1}
            className={style.agentListContainer}>
              {(() => {
                const cardColor = createColorPicker();
                return flowAgentsDetails.map((agent: WorkflowAgent, index: number) => (
                    <WorkflowAgents
                      flowAgentsDetails={flowAgentsDetails}
                      setFlowAgentDetails={setFlowAgentDetails}
                      agent={agent}
                      appId={appId}
                      deleteAgent={deleteAgent}
                      setOpenModal={setOpenModal}
                      setDeleteAgentData={setDeleteAgentData}
                      canDeleteAgents={canDeleteAgents}
                      canEditAgents={canEditAgents}
                      cardColor={cardColor(index)}
                    />
                  ))
              })()}
          </motion.div>}
          {(flowAgentsDetails.length === 0) && !loading && canCreateAgents &&
            <div className={style.aiAgentsEmptyContainer}>
              <img src={aiAgentsIcon}/>
              <h1 style={{ color: "#000000", fontWeight: 700, fontSize: 16, marginBottom: 20, paddingTop: 12, marginTop: 18}}>No Agents Available</h1>
              <div style={{ width: 330, textAlign: "center", color: "#292D32", fontSize: 14, marginBottom: 20 }}>There are currently no agents listed—please check back later or add a new agent to get started.</div>
                <button className={style.createAgentBtn} onClick={() => {
                  handleRouteNavigation("workFlowAgents/create")
                }}>Add Agent</button>

          </div>}
        </>
        }

        {<Modal
          className='agent-delete-modal'
          visible={openModal}
          title="DELETE AGENT"
          onCancel={() => {
            setAgentName("")
            setOpenModal(false)
          }}
          destroyOnClose={true}
          footer={
            <>
            <Button className={style.agentDeleteModalCancelBtn} color="light" size="small" onClick={() => {
              setAgentName("")
              setOpenModal(false)
              }}>
              Cancel
              </Button>
              <Button
                className={style.agentDeleteModalConfirmBtn}
                size="small"
                disabled={((agentName && validateNameError !== "") || !agentName)}
                loading={loading}
                onClick={() => {
                  if(agentName !== deleteAgentData.name){
                    setValidateNameError("Please enter valid agent name")
                    return
                  }
                  deleteAgent(deleteAgentData.id)
                }}
              >
                Submit
              </Button>
              </>
          }
        >
          <>
            <p className={style.agentNameConfirm}>Do you want to remove the agent ? <span className={style.deleteAgentName}>{deleteAgentData.name}</span></p>
            <p className={style.agentNameConfirmText}>Please confirm agent name to delete</p>
            <input className={style.agentNameConfirmInput} placeholder='Enter agent name' value={agentName} onChange={(e) => {
              setValidateNameError("")
              setAgentName(e.target.value)}}/>
            {validateNameError && <span className={style.errorMessage}>{validateNameError}</span>}
          </>
           </Modal>}

      </div>
      </motion.div> : 
      <div className="viewWrapper">
        <NoData
          svg={WarningIcon}
          header='Not Authorized'
          content='Please request owner of this organization to provide access'
          noButton={true}
        />
      </div>}
    </>
  )
}

export {
  AIAgents
}
